<template>
    <v-dialog v-model="show" persistent max-width="500">
        <v-card>
            <v-card-title class="headline">
                <v-icon :color="categoryColor" class="mr-2">
                    {{ categoryIcon }}
                </v-icon>
                <span :style="{ color: categoryColor }">{{ titleText }}</span>
            </v-card-title>

            <v-card-text>
                <div v-if="currentStatus" class="mb-2">
                    <strong>Código:</strong> {{ currentStatus }}
                </div>
                <div class="mb-2" v-if="currentCategory">
                    <v-chip small :color="categoryColor" text-color="white" class="font-weight-medium">
                        <v-icon left small>{{ categoryIcon }}</v-icon>
                        {{ currentCategory }}
                    </v-chip>
                </div>
                <div :style="{ color: categoryColor }">
                    {{ currentMessage }}
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="cancel" v-if="showCancel">
                    {{ $t('system.errors.buttons.close') }}
                </v-btn>
                <v-btn color="red accent-4" class="white--text" @click="logout" v-if="showLogout">
                    {{ $t('system.errors.buttons.logout') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {
    prepareErrorForDisplay,
    ErrorCategories,
    ErrorCategoryIcons,
    ErrorCategoryColors,
    getErrorCategoryTranslation
} from '@/utils/errorCategories';
import {
    isLimiteApiExternaAxiosError,
    markLimiteApiExternaDisplayed,
} from '@/utils/limiteApiExterna';

export default {
    name: "ErroSistema",

    data: () => ({
        show: false,
        currentType: ErrorCategories.SISTEMA,
        currentCategory: null,
        currentMessage: "",
        currentStatus: null,
        currentIsLimiteApiExterna: false,
    }),

    computed: {
        titleText() {
            if (this.currentIsLimiteApiExterna) {
                return this.$t('system.errors.titles.apiLimitExceeded');
            }
            if (this.currentStatus === 401 || this.currentStatus === 403) {
                return this.$t('system.errors.titles.authorizationError');
            }
            return this.$t('system.errors.titles.errorOf', { type: this.currentType });
        },

        categoryIcon() {
            return ErrorCategoryIcons[this.currentType] || ErrorCategoryIcons[ErrorCategories.SISTEMA];
        },

        categoryColor() {
            return ErrorCategoryColors[this.currentType] || ErrorCategoryColors[ErrorCategories.SISTEMA];
        },

        showCancel() {
            if (this.currentIsLimiteApiExterna) {
                return true;
            }
            return this.currentStatus !== 401 && this.currentStatus !== 403;
        },

        showLogout() {
            if (this.currentIsLimiteApiExterna) {
                return false;
            }
            return this.currentStatus === 401 || this.currentStatus === 403;
        }
    },

    methods: {
        showError(error, type = null) {
            if (error && error._limiteApiExternaDisplayed) {
                return;
            }

            const explicitCategory = type || null;
            const errorInfo = prepareErrorForDisplay(error, explicitCategory, this.$t.bind(this));
            this.currentIsLimiteApiExterna = isLimiteApiExternaAxiosError(error);

            // Se um tipo válido foi fornecido explicitamente, usa ele
            if (type && Object.values(ErrorCategories).includes(type)) {
                this.currentType = getErrorCategoryTranslation(type, this.$t.bind(this));
                this.currentCategory = getErrorCategoryTranslation(type, this.$t.bind(this));
            } else {
                // Caso contrário, usa a categoria determinada automaticamente
                this.currentType = getErrorCategoryTranslation(errorInfo.category, this.$t.bind(this));
                this.currentCategory = getErrorCategoryTranslation(errorInfo.category, this.$t.bind(this));
            }

            this.currentMessage = errorInfo.message;
            this.currentStatus = errorInfo.status;

            this.show = true;
            if (this.currentIsLimiteApiExterna) {
                markLimiteApiExternaDisplayed(error);
            }
        },

        cancel() {
            this.show = false;
            setTimeout(() => {
                this.currentMessage = "";
                this.currentStatus = null;
                this.currentType = ErrorCategories.SISTEMA;
                this.currentCategory = null;
                this.currentIsLimiteApiExterna = false;
            }, 300);
        },

        logout() {
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("api");

            var id = window.setTimeout(function () { }, 0);
            while (id--) {
                window.clearTimeout(id);
            }

            this.show = false;

            this.$router.push({ path: "/" });
        }
    }
}
</script>

<style scoped>
.v-icon {
    animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.7;
    }
}
</style>